"use strict";
const T = function (...args) { return appn.translator.getString(...args); };
const TP = function (...args) { return appn.translator.getPluralString(...args); };
var appn;
(function (appn) {
    var translator;
    (function (translator) {
        function getString(...args) {
            var _a, _b, _c;
            let template = (_a = args.shift()) !== null && _a !== void 0 ? _a : '';
            if (appn.translator.resx) {
                let cleanKey = getResourceKeyFor(template);
                if (appn.translator.resx[cleanKey] !== undefined)
                    template = appn.translator.resx[cleanKey];
                else if (appn.isDebug || appn.isTestSuiteRequest) {
                    let missing = (_c = JSON.parse((_b = appn.localStorage.getItem('appn.missingkeys')) !== null && _b !== void 0 ? _b : '{}')) !== null && _c !== void 0 ? _c : {};
                    if (missing[translator.culture] === undefined)
                        missing[translator.culture] = [];
                    if (!missing[translator.culture].includes(template)) {
                        missing[translator.culture].push(template);
                        appn.localStorage.setItem('appn.missingkeys', JSON.stringify(missing));
                    }
                }
            }
            if (args.length === 0)
                return template;
            return formatString(template, args);
        }
        translator.getString = getString;
        ;
        function formatString(val, params) {
            return val.replace(/{(\d+)}/g, (match, index) => {
                return typeof params[index] !== 'undefined' ? params[index] : match;
            });
        }
        function getPluralString(...args) {
            let zero = args.shift();
            let one = args.shift();
            let other = args.shift();
            let two = other;
            let few = other;
            let many = other;
            if (args.length > 1) {
                few = args.shift();
                many = args.shift();
                other = args.shift();
            }
            let number = args.shift();
            if (number === 0)
                return getString(zero);
            var match = translator.plurals.find(r => r.Min <= number && number <= r.Max);
            switch (match === null || match === void 0 ? void 0 : match.Type) {
                case CLDRType.One:
                    return getString(one);
                case CLDRType.Two:
                    return getString(two, number);
                case CLDRType.Few:
                    return getString(few, number);
                case CLDRType.Many:
                    return getString(many, number);
                default:
                    return getString(other, number);
            }
        }
        translator.getPluralString = getPluralString;
        function getResourceKeyFor(text) {
            var normed = normaliseString(text);
            var cleaned = normed.substring(0, translator.RESXKEYLENGTH)
                .replace(/\s+/g, '_')
                .replace(/[^\p{L}\p{N}_]+/gu, '');
            return `${cleaned}_${getPersistentHashCode(normed)}`;
        }
        translator.getResourceKeyFor = getResourceKeyFor;
        function normaliseString(val) {
            return val.replace('/\r/g', '').replace(/[ \t]{2,}/g, ' ');
        }
        translator.normaliseString = normaliseString;
        function getPersistentHashCode(str) {
            let hash1 = iadd(5381 << 16, 5381);
            let hash2 = hash1;
            for (let i = 0; i < str.length; i += 2) {
                hash1 = iadd(hash1 << 5, hash1) ^ str.charCodeAt(i);
                if (i === str.length - 1) {
                    break;
                }
                hash2 = iadd(hash2 << 5, hash2) ^ str.charCodeAt(i + 1);
            }
            return Math.abs(iadd(hash1, Math.imul(hash2, 1566083941)));
        }
        translator.getPersistentHashCode = getPersistentHashCode;
        function i32(value) {
            return value | 0;
        }
        translator.i32 = i32;
        function iadd(a, b) {
            return ((a | 0) + (b | 0)) | 0;
        }
        translator.iadd = iadd;
        let CLDRType;
        (function (CLDRType) {
            CLDRType[CLDRType["One"] = 0] = "One";
            CLDRType[CLDRType["Two"] = 1] = "Two";
            CLDRType[CLDRType["Few"] = 2] = "Few";
            CLDRType[CLDRType["Many"] = 3] = "Many";
            CLDRType[CLDRType["Other"] = 4] = "Other";
        })(CLDRType = translator.CLDRType || (translator.CLDRType = {}));
    })(translator = appn.translator || (appn.translator = {}));
})(appn || (appn = {}));
